import React, { useState } from "react";
import { FaBell, FaUser } from "react-icons/fa";
import { GoHomeFill } from "react-icons/go";
import { Outlet, NavLink } from "react-router-dom";
import SideBar from "./pages/SideBar";
import NotifcationBell from "./components/NotificationBell";
import { useTranslation } from "react-i18next";

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  // Navigation items component for reusability
  const NavItems = ({
    className = "",
    showLabels = false,
    isVertical = false,
  }) => (
    <div
      className={`flex ${
        isVertical ?  "flex-col gap-y-7" : "gap-x-7"
      } ${className}`}
    >
      <NavLink
        to="/"
        className={({ isActive }) =>
          `flex ${isVertical ? "flex-row" : "flex-col"} items-center  ${
            isActive ? "text-orange-400" : "text-gray-800"
          } hover:text-orange-400 transition-colors`
        }
      >
        <span className="text-md ">{t('Home')}</span>
      </NavLink>

      <NavLink
        to="/go"
        className={({ isActive }) =>
          `flex ${isVertical ? "flex-row" : "flex-col"} items-center  ${
            isActive ? "text-orange-400" : "text-gray-800"
          } hover:text-orange-400 transition-colors`
        }
      >
        <span className="text-md ">{t('mysub')}</span>
      </NavLink>

      <NavLink
        to="/update"
        className={({ isActive }) =>
          `flex ${isVertical ? "flex-row" : "flex-col"} items-center  ${
            isActive ? "text-orange-400" : "text-gray-800"
          } hover:text-orange-400 transition-colors`
        }
      >
        <span className="text-md ">{t('Profile')}</span>
      </NavLink>
    </div>
  );

  return (
    <div className="flex flex-col h-screen overflow-y-auto scroll-smooth focus:scroll-auto bg-slate-100 space-y-2">
      {/* Header */}
      <div className="fixed w-full lg:pt-9 lg:px-9  z-10 bg-slate-100 l">
        <header className="flex items-center justify-between py-2 px-4 bg-white shadow-lg z-1 lg:rounded-full lg:mx-40 xl:mx-60 ">
          <div className="flex items-center">
            <svg
              className="h-8 w-8"
              viewBox="0 0 158 146"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_12_399)">
                <path
                  d="M12.5905 145.999C9.99855 145.999 7.75113 145.401 5.86461 144.214C3.97809 143.027 2.52629 141.423 1.51742 139.409C0.50854 137.395 0 135.16 0 132.696C0 130.24 0.50854 127.997 1.51742 125.983C2.52629 123.969 3.97809 122.364 5.86461 121.177C7.75113 119.99 9.99034 119.393 12.5905 119.393C14.559 119.393 16.3307 119.736 17.8973 120.432C19.4721 121.128 20.8091 122.078 21.9082 123.281C23.0073 124.485 23.8357 125.885 24.3853 127.481H21.2766C20.6205 125.885 19.587 124.616 18.168 123.674C16.749 122.733 14.9691 122.258 12.8201 122.258C10.7203 122.258 8.93225 122.725 7.45585 123.65C5.97124 124.583 4.85573 125.827 4.09292 127.399C3.33011 128.971 2.95281 130.739 2.95281 132.696C2.95281 134.636 3.33011 136.396 4.09292 137.976C4.85573 139.556 5.97124 140.817 7.45585 141.742C8.94046 142.675 10.7285 143.134 12.8201 143.134C14.9691 143.134 16.749 142.659 18.168 141.717C19.587 140.776 20.6205 139.507 21.2766 137.911H24.3853C23.8357 139.483 23.0073 140.874 21.9082 142.094C20.8091 143.314 19.4721 144.264 17.8973 144.959C16.3307 145.655 14.559 145.999 12.5905 145.999Z"
                  fill="#66B8D9"
                />
                <path
                  d="M30.7676 145.687V119.703H33.7204V142.863H47.9185V145.687H30.7676Z"
                  fill="#66B8D9"
                />
                <path
                  d="M53.6914 145.687V119.703H72.8437V122.528H56.6442V131.238H71.113V134.103H56.6442V142.855H72.8437V145.679H53.6914V145.687Z"
                  fill="#66B8D9"
                />
                <path
                  d="M76.502 145.687L87.5504 119.703H91.2496L102.298 145.687H99.0335L95.8511 138.148H82.9489L79.7665 145.687H76.502ZM84.089 135.438H94.711L89.4041 122.757L84.089 135.438Z"
                  fill="#66B8D9"
                />
                <path
                  d="M107.572 145.687V119.703H110.993L127.077 141.57V119.703H130.03V145.687H126.61L110.525 123.747V145.687H107.572Z"
                  fill="#66B8D9"
                />
                <path
                  d="M147.691 145.999C145.123 145.999 143.04 145.655 141.44 144.959C139.841 144.263 138.644 143.305 137.84 142.077C137.036 140.849 136.577 139.458 136.445 137.918H139.513C139.595 139.171 140.013 140.186 140.768 140.964C141.531 141.733 142.531 142.307 143.778 142.675C145.025 143.043 146.395 143.223 147.887 143.223C150.086 143.223 151.833 142.839 153.12 142.069C154.408 141.3 155.048 140.153 155.048 138.631C155.048 137.714 154.728 136.977 154.088 136.412C153.449 135.847 152.596 135.389 151.529 135.02C150.471 134.652 149.306 134.325 148.051 134.022C146.797 133.719 145.525 133.399 144.254 133.064C142.982 132.728 141.818 132.294 140.751 131.77C139.693 131.246 138.84 130.575 138.192 129.748C137.553 128.921 137.233 127.874 137.233 126.588C137.233 124.468 138.053 122.741 139.693 121.406C141.334 120.072 143.778 119.4 147.026 119.4C149.331 119.4 151.234 119.744 152.727 120.44C154.22 121.136 155.343 122.045 156.09 123.166C156.836 124.288 157.246 125.508 157.328 126.817H154.302C154.146 125.508 153.49 124.402 152.333 123.502C151.177 122.601 149.413 122.151 147.026 122.151C145.558 122.151 144.369 122.298 143.45 122.585C142.531 122.872 141.834 123.248 141.342 123.707C140.858 124.165 140.53 124.64 140.358 125.139C140.186 125.639 140.104 126.105 140.104 126.555C140.104 127.415 140.423 128.119 141.063 128.659C141.703 129.2 142.556 129.642 143.622 129.994C144.68 130.346 145.853 130.665 147.141 130.952C148.429 131.238 149.7 131.558 150.98 131.91C152.251 132.262 153.416 132.712 154.482 133.244C155.54 133.784 156.393 134.464 157.041 135.307C157.681 136.142 158.001 137.214 158.001 138.524C158.001 140.931 157.082 142.781 155.245 144.075C153.408 145.352 150.889 145.999 147.691 145.999Z"
                  fill="#66B8D9"
                />
                <path
                  d="M128.71 23.3973L124.461 7.0896C123.378 2.91443 119.605 0 115.283 0H46.3265C42.0039 0 38.2308 2.91443 37.1481 7.08142L32.8748 23.4956C32.4893 24.9855 33.3833 26.5001 34.8679 26.8848C36.3607 27.2696 37.8782 26.3773 38.2637 24.8955L42.537 8.48133C42.537 8.47314 42.5452 8.46495 42.5452 8.44858C42.9389 6.97499 44.5548 6.18908 46.0066 6.67209C47.1057 7.0323 48.336 7.44163 48.336 7.44163C51.945 8.50589 55.554 9.29999 59.163 9.93854C66.381 11.1829 73.5908 11.756 80.8087 11.7478C88.0267 11.7396 95.2365 11.1583 102.454 9.91398C106.063 9.26724 109.672 8.47314 113.281 7.41707C113.281 7.41707 114.512 7.00774 115.603 6.64753C117.046 6.1727 118.654 6.95862 119.056 8.42402C119.064 8.44039 119.064 8.45677 119.072 8.47314L123.346 24.8791C123.674 26.1317 124.806 26.9585 126.044 26.9585C126.413 26.9585 126.791 26.8848 127.16 26.7293C128.431 26.1972 129.063 24.7399 128.71 23.3973Z"
                  fill="#FF8C00"
                />
                <path
                  d="M145.261 37.5756L144.343 34.5138C143.547 31.8777 141.48 29.8065 138.831 29.0124L135.763 28.0955C134.631 27.7598 134.631 26.1552 135.763 25.8196L138.831 24.9027C141.472 24.1086 143.547 22.0456 144.343 19.4013L145.261 16.3395C145.597 15.2097 147.205 15.2097 147.541 16.3395L148.46 19.4013C149.256 22.0374 151.323 24.1086 153.972 24.9027L157.04 25.8196C158.172 26.1552 158.172 27.7598 157.04 28.0955L153.972 29.0124C151.331 29.8065 149.256 31.8695 148.46 34.5138L147.541 37.5756C147.205 38.7053 145.597 38.7053 145.261 37.5756Z"
                  fill="#66B8D9"
                />
                <path
                  d="M66.2897 70.7578H42.2243C40.6823 70.7578 39.4355 72.0022 39.4355 73.5413C39.4355 75.0803 40.6823 76.3247 42.2243 76.3247H66.2897C67.8317 76.3247 69.0785 75.0803 69.0785 73.5413C69.0785 72.0022 67.8317 70.7578 66.2897 70.7578Z"
                  fill="#FF8C00"
                />
                <path
                  d="M117.013 32.5911C113.027 32.5911 103.43 32.0836 93.2021 37.9452C85.8446 42.1613 79.1106 48.1948 75.1079 56.1768C74.1072 58.1743 73.287 60.2619 72.5816 62.3986C71.8926 64.5435 71.4333 66.7621 71.0724 68.997C70.9248 70.1186 70.7689 71.2401 70.7033 72.3699L70.6377 73.2213L70.6213 73.4341L70.6131 73.6715L70.5967 74.0481L70.5146 75.1615C70.3834 76.6187 70.1783 78.0596 69.8256 79.4595C69.1531 82.2675 68.1688 84.9773 66.7416 87.4578C66.028 88.694 65.298 89.922 64.4286 91.0517C63.5673 92.1897 62.6241 93.2621 61.6152 94.2691C60.6063 95.276 59.54 96.2257 58.4163 97.1016C57.2844 97.9694 56.0705 98.7308 54.8319 99.4348C52.3631 100.876 49.6563 101.899 46.8511 102.578C45.4486 102.947 44.005 103.16 42.5532 103.307L41.4459 103.397L40.2319 103.454C39.4855 103.512 38.7473 103.495 38.0009 103.504C36.5163 103.463 35.0235 103.34 33.5389 103.094C32.0543 102.865 30.5615 102.554 29.1015 102.104C23.2369 100.376 17.6347 96.9543 13.0907 92.0832C12.5739 91.5347 11.9834 90.7898 11.3764 89.9793C7.22606 84.396 5.10988 77.5111 5.67583 70.5852C5.70864 70.2086 5.74145 69.8402 5.78246 69.4636C7.83303 51.5268 23.4009 38.158 41.4869 38.158H59.0479V44.2161C59.0479 46.9668 61.2871 49.2018 64.0431 49.2018C66.4627 49.2018 68.4723 47.4908 68.9398 45.2149C69.0136 44.9611 69.0628 44.6991 69.0628 44.4208V32.6075C69.0628 32.5993 69.0546 32.5911 69.0464 32.5911H41.5279C18.9471 32.5911 0.213134 50.5853 -0.000124912 73.1149C-0.213383 95.8491 18.2581 114.408 40.9865 114.408H41.5033C52.2892 114.408 62.4108 110.192 70.0061 102.546C77.5932 94.8994 81.7189 84.7562 81.6205 73.9908L81.6123 73.4996C81.6123 54.0155 97.5 38.158 117.021 38.158C129.489 38.158 140.455 44.6255 146.771 54.3675C148.165 56.7498 157.303 73.6716 144.597 88.7185C144.089 89.2589 143.58 89.7828 143.08 90.2904C138.798 94.5802 134.09 97.7647 129.021 100.073C127.758 100.663 126.454 101.17 125.133 101.621C124.477 101.883 123.796 102.071 123.116 102.284C122.861 102.366 122.615 102.431 122.353 102.488C122.099 102.546 121.844 102.611 121.59 102.693L121.073 102.824C119.695 103.209 118.268 103.397 116.816 103.667L115.717 103.815C115.365 103.864 115.012 103.872 114.659 103.921C114.29 103.978 113.921 104.019 113.552 104.044C113.158 104.068 112.756 104.126 112.363 104.126C111.985 104.134 111.608 104.15 111.222 104.183L110.066 104.216C109.672 104.24 109.295 104.216 108.901 104.208C108.507 104.199 108.106 104.216 107.712 104.191C106.121 104.15 104.488 104.052 102.823 103.823C99.9771 103.43 95.0148 101.138 93.6368 100.024C92.5623 99.1565 91.0285 99.0173 89.9622 99.8933C88.6088 101.015 88.6088 103.021 89.8802 104.134C97.377 110.749 107.015 114.392 117.03 114.392C139.627 114.392 158.016 96.0374 158.016 73.4833C158.016 50.9291 139.619 32.5911 117.013 32.5911Z"
                  fill="#FF8C00"
                />
              </g>
              <defs>
                <clipPath id="clip0_12_399">
                  <rect width="158" height="146" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div className=" flex items-center space-x-2">
            <div className="hidden lg:flex items-center space-x-8 mx-4">
              <NavItems showLabels={true} isVertical={false} />
            </div>
            <NotifcationBell />
            <button
              onClick={toggleSidebar}
              className={`flex  items-center  text-gray-600 hover:text-orange-400 transition-colors`}
            >
              <svg
                className="h-8 "
                viewBox="0 0 43 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.93213 21H37.0085M5.93213 10.6412H37.0085M5.93213 31.3588H37.0085"
                  stroke="#344054"
                  strokeWidth="3.45293"
                  strokeLinecap="round"
                 strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </header>
      </div>
      {/* Content */}
    
      <main   className="flex-1 lg:mx-40 xl:mx-60 px-8 pt-32 lg:pt-24 max-[450px]:px-2 max-[450px]:pt-20 sm:px-2 sm:pt-20 pb-20 lg:pb-8">
        <Outlet />
      </main>

      {/* Bottom Navigation - Only visible on mobile and tablet */}
      <nav className="fixed bottom-0 left-0 w-full bg-white shadow-[rgba(0,0,0,0.1)_5px_0px_20px_2px] lg:hidden">
        <div className="flex justify-around items-center p-1">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex flex-col items-center p-2 text-2xl ${
                isActive ? "text-orange-400" : "text-gray-800"
              }`
            }
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.62 8.35369L17.6837 3.50068C15.793 2.17603 12.8909 2.24829 11.0725 3.65723L5.03935 8.36573C3.83512 9.30502 2.88379 11.2318 2.88379 12.7491V21.0582C2.88379 24.129 5.37653 26.6338 8.44729 26.6338H21.4288C24.4996 26.6338 26.9923 24.141 26.9923 21.0703V12.9056C26.9923 11.2799 25.9446 9.28094 24.62 8.35369ZM15.8412 21.8169C15.8412 22.3106 15.4318 22.72 14.938 22.72C14.4443 22.72 14.0349 22.3106 14.0349 21.8169V18.2042C14.0349 17.7105 14.4443 17.3011 14.938 17.3011C15.4318 17.3011 15.8412 17.7105 15.8412 18.2042V21.8169Z"
                fill="#1D5761"
              />
            </svg>
            <span className="text-[#1D5761] text-[12.042211532592773px] font-['Inter'] font-medium leading-[1.2]">
              {t('Home')}
            </span>
          </NavLink>
          <NavLink
            to="/go"
            className={({ isActive }) =>
              `flex flex-col items-center p-2 text-2xl ${
                isActive ? "text-orange-400" : "text-gray-800"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  className="w-8"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.13525 15.7958C4.13525 15.4764 4.26213 15.1701 4.48796 14.9443C4.7138 14.7184 5.0201 14.5916 5.33948 14.5916H10.1564C10.4757 14.5916 10.782 14.7184 11.0079 14.9443C11.2337 15.1701 11.3606 15.4764 11.3606 15.7958V23.0211C11.3606 23.3405 11.2337 23.6468 11.0079 23.8726C10.782 24.0984 10.4757 24.2253 10.1564 24.2253H5.33948C5.0201 24.2253 4.7138 24.0984 4.48796 23.8726C4.26213 23.6468 4.13525 23.3405 4.13525 23.0211V15.7958Z"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.5859 10.9789C18.5859 10.6595 18.7128 10.3532 18.9386 10.1274C19.1645 9.90153 19.4708 9.77466 19.7902 9.77466H24.607C24.9264 9.77466 25.2327 9.90153 25.4586 10.1274C25.6844 10.3532 25.8113 10.6595 25.8113 10.9789V23.0211C25.8113 23.3405 25.6844 23.6468 25.4586 23.8726C25.2327 24.0984 24.9264 24.2253 24.607 24.2253H19.7902C19.4708 24.2253 19.1645 24.0984 18.9386 23.8726C18.7128 23.6468 18.5859 23.3405 18.5859 23.0211V10.9789Z"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.3604 6.16198C11.3604 5.84261 11.4872 5.53631 11.7131 5.31047C11.9389 5.08464 12.2452 4.95776 12.5646 4.95776H17.3815C17.7008 4.95776 18.0071 5.08464 18.233 5.31047C18.4588 5.53631 18.5857 5.84261 18.5857 6.16198V23.0211C18.5857 23.3405 18.4588 23.6468 18.233 23.8726C18.0071 24.0984 17.7008 24.2253 17.3815 24.2253H12.5646C12.2452 24.2253 11.9389 24.0984 11.7131 23.8726C11.4872 23.6468 11.3604 23.3405 11.3604 23.0211V6.16198Z"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.33936 24.2253H22.1985"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span className="text-[#1D5761] text-[12.042211532592773px] font-['Inter'] font-medium leading-[1.2]">
                  {t('mysub')}
                </span>
              </>
            )}
          </NavLink>
          <NavLink
           onClick={toggleSidebar}
            className={({ isActive }) =>
              `flex flex-col items-center p-2 text-2xl ${
                isActive ? "text-orange-400" : "text-gray-800"
              }`
            }
          >
            {({ isActive }) => (
              <>
                {" "}
                <svg
                  className="w-8"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.40283 14.5915C4.40283 16.0148 4.68316 17.4241 5.22782 18.7391C5.77248 20.054 6.57081 21.2487 7.57721 22.2551C8.58361 23.2615 9.77838 24.0599 11.0933 24.6045C12.4082 25.1492 13.8176 25.4295 15.2408 25.4295C16.6641 25.4295 18.0734 25.1492 19.3883 24.6045C20.7033 24.0599 21.898 23.2615 22.9044 22.2551C23.9108 21.2487 24.7092 20.054 25.2538 18.7391C25.7985 17.4241 26.0788 16.0148 26.0788 14.5915C26.0788 13.1683 25.7985 11.7589 25.2538 10.444C24.7092 9.12909 23.9108 7.93431 22.9044 6.92791C21.898 5.92151 20.7033 5.12319 19.3883 4.57853C18.0734 4.03387 16.6641 3.75354 15.2408 3.75354C13.8176 3.75354 12.4082 4.03387 11.0933 4.57853C9.77838 5.12319 8.58361 5.92151 7.57721 6.92791C6.57081 7.93431 5.77248 9.12909 5.22782 10.444C4.68316 11.7589 4.40283 13.1683 4.40283 14.5915Z"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.6279 12.1831C11.6279 13.1412 12.0085 14.0601 12.6861 14.7376C13.3636 15.4151 14.2825 15.7958 15.2406 15.7958C16.1987 15.7958 17.1176 15.4151 17.7951 14.7376C18.4726 14.0601 18.8533 13.1412 18.8533 12.1831C18.8533 11.225 18.4726 10.3061 17.7951 9.62856C17.1176 8.95105 16.1987 8.57043 15.2406 8.57043C14.2825 8.57043 13.3636 8.95105 12.6861 9.62856C12.0085 10.3061 11.6279 11.225 11.6279 12.1831Z"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.21777 22.8392C8.51583 21.8472 9.12572 20.9777 9.95697 20.3597C10.7882 19.7417 11.7965 19.4081 12.8323 19.4084H17.6492C18.6864 19.4081 19.6959 19.7425 20.5278 20.3619C21.3596 20.9813 21.9693 21.8527 22.2662 22.8465"
                    stroke={isActive ? "#66B8D9" : "#1C1C1C"}
                    strokeWidth="1.80633"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-[#1D5761] text-[12.042211532592773px] font-['Inter'] font-medium leading-[1.2]">
                  {t('Profile')}
                </span>
              </>
            )}
          </NavLink>
        </div>
      </nav>

      <SideBar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
    </div>
  );
};

export default Layout;
